import Vue from 'vue';
export const EventBus = new Vue();
/* Keep the key and value COMPLETELY identical to flag any duplicates
 * Using an existing trigger will send the data to other EventBus objects on the
 * off chance they're also rendered in the same page
 *
 * Modularize this into different event_bus/<Name> directory once overpopulated
 */
export const EventBusTriggers = {
    setAgentBreakdown: 'setAgentBreakdown',
    addAgentBreakdown: 'addAgentBreakdown',
    loadMessengerMessages: 'loadMessengerMessages',
    setInboxWidgetTab: 'setInboxWidgetTab',
};
